import React, {useState} from 'react';
import { SearchBarStyle } from '../../../../styles/common';
import styled from 'styled-components';
import theme from '../../../../styles/theme';
import { useGetInspectSel } from '../../../../interface/inspect';

import moment from 'moment';
import Button from '../../../common/Button';
import FullModal from '../../../common/modal/FullModal';

import { useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import { useGetCodeList } from '../../../../interface/common';
import InspectItem from './InspectItem';
import CommonDataGrid from '../../../common/CommonDataGrid';
import { useNavigate } from 'react-router-dom';

const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        // display: inline-box;
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        // width: calc(100% - 24px);
        margin: 0;
        
        color: ${theme.color.black};
    }
    div {
        // width: calc(100% - 24px);
        // padding: 12px;
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const columns = [
    { field: 'isp_nm', headerName: '과업명', flex: 1 },
    { field: 'isp_tpnm', headerName: '조사유형', flex: 0.5 },
    { field: 'isp_kdnm', headerName: '조사대상', flex: 0.5 },
    { field: 'sdate', headerName: '조사기간(시작)', valueGetter: (param) => moment(param.sdate).format('YYYY/MM/DD') ,flex: 0.5 },
    { field: 'edate', headerName: '조사기간(종료)', valueGetter: (param) => moment(param.edate).format('YYYY/MM/DD') ,flex: 0.5 },
    { field: 'isp_stnm', headerName: '진행상태', flex: 0.5 },
    { field: 'contents', headerName: '내용', flex: 1 },
]

const InspectMain = () => {

  const navigate = useNavigate();

    const [sendParam, setSendParam] = useState({});
    const [regOpen, setRegOpen] = useState(false);
    const [target, setTarget] = useState();

    const [list, setList] = useState([]);

    const {data : ispTpList} = useGetCodeList('isp_tp');
    const {data : ispKdList} = useGetCodeList('isp_kd');
    const {data, isError, isLoading, refetch } = useGetInspectSel(sendParam);

    const handleValueChange = (id, val) => {
        sendParam[id]=val;
    }

    const goSearch = () => {
        refetch();
    }

    useEffect(()=>{
        if(data){
            setList(data.map((item,index)=>({...item,id:index})));
        }else{
            setList([])
        }
    },[data])

    return (
        <MainWrap>
            <h3>자산 조사</h3>
            <div>
                <SearchBarStyle>
                    <div style={{display:'flex',gap: '1rem',flexWrap:'wrap', justifyContent:'flex-start', alignItems:'center'}}>
                        <FormControl style={{width:'10rem'}} size='small'>
                            <InputLabel id='ispTp-label'>조사유형</InputLabel>
                            <Select label="조사유형" labelId='ispTp-label' size='small'>
                                <MenuItem value={''} onClick={()=>handleValueChange('isp_tp','')} >없음</MenuItem>
                                {ispTpList && ispTpList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.code} 
                                                onClick={()=>handleValueChange('isp_tp',item.code)}
                                            >
                                                {item.value}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        <FormControl style={{width:'10rem'}} size='small'>
                            <InputLabel id='ispKd-label'>조사대상</InputLabel>
                            <Select label="조사대상" labelId='ispKd-label' size='small'>
                                <MenuItem value={''} onClick={()=>handleValueChange('isp_kd','')} >없음</MenuItem>
                                {ispKdList && ispKdList.map((item,index)=>{
                                    return <MenuItem 
                                                key={index} 
                                                value={item.code} 
                                                onClick={()=>handleValueChange('isp_kd',item.code)}
                                            >
                                                {item.value}
                                            </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        <TextField 
                            id='sdate'
                            label='작업시작일(From)' 
                            style={{width:'10rem'}} 
                            InputLabelProps={{shrink:true}} 
                            type='date' 
                            size='small' 
                            onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                        />
                        ~
                        <TextField 
                            id='edate'
                            label='작업종료일(TO)' 
                            style={{width:'10rem'}} 
                            InputLabelProps={{shrink:true}} 
                            type='date' 
                            size='small' 
                            onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                        />
                    </div>
                    <div style={{display:'flex',justifyContent:'flex-end', flexWrap:'wrap', alignItems:'center'}}>
                        <Button onClick={goSearch} style={{width:'120px'}}>검색</Button>
                        <Button onClick={()=>{setTarget();setRegOpen(true)}} style={{width:'120px'}}>등록</Button>
                    </div>
                </SearchBarStyle>
            </div>
            <div style={{width:'100%', height: '80vh'}}>
                <CommonDataGrid
                    isLoading={isLoading}
                    list={list}
                    columns={columns}
                    onRowClick={(e)=>{navigate('/admin/inspects/'+e.row.sno+'/ispDetail')}}
                    // onRowClick={(e)=>{{setTarget(e.row);setRegOpen(true)}}}
                    />
            </div>
            <FullModal open={regOpen}>
                <DetailWrap target={target} onClose={setRegOpen} />
            </FullModal>
        </MainWrap>
    )

}

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;

const DetailWrap = ({target, onClose}) => {
    return (
        <DetailWrapStyle>
            <InspectItem item={target} onClose={onClose}/>
        </DetailWrapStyle>
    )
}
export default InspectMain;